export default __webpack_public_path__ + "static/media/check-mark 2.81534862.svg";